import { IBuildersList } from '../../types/builders';

export const createCianAnalyticsProducts = (buildersList?: IBuildersList) => {
  if (buildersList) {
    return buildersList.constructorsList.map(({ id, name }, index) => ({
      id,
      extra: { name },
      offerType: 'CountryBuilder',
      position: index + 1,
    }));
  }

  return [];
};
